import { NAV_PATHS } from '@modules/common/constants';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

interface OpenInCollectionLinkProps {
  viewToken: string;
}

export const OpenInCollectionLink = ({
  viewToken,
}: OpenInCollectionLinkProps) => {
  return (
    <Button
      component={Link}
      to={`/${NAV_PATHS.COLLECTION}/${viewToken}`}
      target="_blank"
      variant="text"
      color="success"
      size="small"
    >
      Open
    </Button>
  );
};
